module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2b"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/frontmatter01#frontmatter01"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/frontmatter02#frontmatter02"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part01#part01"
    }
  }, [_c('strong', [_vm._v("The Production Code 1922–1934")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#chapter01"
    }
  }, [_vm._v("1. Welcome Will Hays!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter02#chapter02"
    }
  }, [_vm._v("2. Welcome Mae West!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter03#chapter03"
    }
  }, [_vm._v("3. Welcome Joe Breen!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02#part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("The Production Code Administration 1934–1966")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. "), _c('em', [_vm._v("Dead End")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. "), _c('em', [_vm._v("Gone With the Wind")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. "), _c('em', [_vm._v("The Outlaw")]), _vm._v(" and "), _c('em', [_vm._v("The Postman Always Rings Twice")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. "), _c('em', [_vm._v("The Bicycle Thief")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08#chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. "), _c('em', [_vm._v("Detective Story")]), _vm._v(" and "), _c('em', [_vm._v("A Streetcar Named Desire")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. "), _c('em', [_vm._v("The Moon Is Blue")]), _vm._v(" and "), _c('em', [_vm._v("The French Line")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. "), _c('em', [_vm._v("Lolita")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. "), _c('em', [_vm._v("Who’s Afraid of Virginia Woolf?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter01#backmatter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Aftermath")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter02#backmatter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix: The Motion Picture Production Code")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter03#backmatter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter04#backmatter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Selected Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter05#backmatter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Selected Filmography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter06#backmatter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Authors")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter07#backmatter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#figures",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Illustrations")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 75
// module chunks = 0